import { object } from "yup";
import { api } from "../app.api";
import { objectToFormData } from "@/shared/utils/data";
import { camelToSnake } from "caseparser";

export const personalizedExerciseApi = api
  .enhanceEndpoints({ addTagTypes: ["PersonalizedExercise", "Exercise"] })
  .injectEndpoints({
    endpoints: (build) => ({
      createPersonalizedExercise: build.mutation({
        query: ({ image, video, exerciseId, branchId }) => ({
          url: `/branchs/${branchId}/personalized-exercises`,
          method: "POST",
          body: objectToFormData(
            camelToSnake({
              image,
              video,
              exerciseId,
              branchId,
            })
          ),
          formData: true,
        }),
        invalidatesTags: ["PersonalizedExercise", "Exercise"],
      }),
      deletePersonalizedExercise: build.mutation({
        query: ({ exerciseId, branchId }) => ({
          url: `/branchs/${branchId}/personalized-exercises/${exerciseId}`,
          method: "DELETE",
        }),
        invalidatesTags: ["PersonalizedExercise", "Exercise"],
      }),
    }),
  });

export const {
  useCreatePersonalizedExerciseMutation,
  useDeletePersonalizedExerciseMutation,
} = personalizedExerciseApi;
